export function setupRemoteMedia(session, store) {

    if (session.mediaElement) {
        console.log({ mediaElement: session.mediaElement })
        session.mediaElement.srcObject = null;
        session.mediaElement.pause();
        delete session.MediaElement;
    }

    // Create new mediaElement
    const mediaElement = document.createElement('video');
    session.mediaElement = mediaElement;

    const remoteStream = new MediaStream();
    session.remoteStream = remoteStream;

    let receivers = session.sessionDescriptionHandler.peerConnection.getReceivers();

    console.log({ msg: "#!#!", receivers });

    receivers.forEach((receiver) => {
        if (receiver.track) {
            console.log("ATFR: ADDING TRACK FROM RECEIVER");
            console.dir(receiver);
            remoteStream.addTrack(receiver.track);
        }
    });
    mediaElement.srcObject = remoteStream;
    mediaElement.id = 'minMedia';
    mediaElement.style = 'border: 1px solid #999;object-fit:fill;height:100%';
    mediaElement.play();

    store.commit('sip/forceSessionsUpdate');

    session.sessionDescriptionHandler.peerConnection.ontrack = () => {
        setupRemoteMedia(session, store)
    };
}